<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerProductAccountList' }">合作产品路径</el-breadcrumb-item>
                <el-breadcrumb-item>合作产品路径{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown-mul'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdownMul
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdownMul>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import vDropdownMul from '@/components/common/dropdown/dropdownMul.vue';

export default {
    name: 'partnerProductAccountEdit',
    components: {
        vSearchSelect,
        vDropdownMul
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.status = 1;
            this.data.performance_basis_code = 1;
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    request_params: { type_code: [11, 15, 91] }
                },
                partner_rid: {
                    request_uri: 'dropdownPartners',
                    title: '合作方',
                    ref: 'partner_rid_ref',
                    type: 'dropdown'
                },
                person_rid: {
                    request_uri: 'dropdownPerson',
                    title: '人员',
                    ref: 'person_rid_ref',
                    type: 'dropdown'
                },
                account_rid: {
                    request_uri: 'searchAccounts',
                    title: '一级商业',
                    ref: 'account_rid_ref',
                    default_option_key: 'account_option',
                    type: 'search_select'
                },
                status: {
                    request_uri: 'dropdownCommonStatus',
                    title: '状态',
                    ref: 'status_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                performance_basis_code: {
                    request_uri: 'dropdownPerformanceBasis',
                    title: '绩效类型',
                    ref: 'performance_basis_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                first_business_date: {
                    title: '最早业务日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'first_business_date_ref',
                    type: 'date'
                },
                latest_business_date: {
                    title: '最晚业务日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'latest_business_date_ref',
                    type: 'date'
                },
                init_month_sequence: {
                    tips: '格式示例：2024-01'
                },
                business_unit_rid: {
                    request_uri: 'dropdownBusinessUnits',
                    title: '业务单元',
                    ref: 'business_unit_rid_ref',
                    type: 'dropdown',
                    select_value: 'rid'
                },
                province_sign: {
                    request_uri: 'dropdownProvinceSign',
                    title: '省份',
                    ref: 'province_sign_ref',
                    type: 'dropdown-mul',
                    tips: '可多选，如果新增时不填，默认填合作方的省份',
                    select_value: 'value'
                },
                lock_sign: {
                    request_uri: 'dropdownPpaLockSign',
                    title: '锁定标记',
                    ref: 'lock_sign_ref',
                    type: 'dropdown-mul',
                    tips: '可多选，目前仅支持最早业务日期',
                    select_value: 'value'
                }
            };
        },
        initFormRule() {
            this.rules = {
                partner_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                person_rid: [{ required: false, message: '请选择人员', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                account_rid: [{ required: true, message: '请输入一级商业搜索', trigger: 'blur' }],
                business_unit_rid: [{ required: true, message: '请选择业务单元', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
                performance_basis_code: [{ required: true, message: '请选择绩效类型', trigger: 'blur' }],
                init_month_sequence: [{ required: true, message: '请输入流向初始月', trigger: 'blur' }],
                init_quantity: [{ required: false, message: '', trigger: 'blur' }],
                init_unit_price_taxincluded: { required: true, validator: checkNumber, trigger: 'blur' },
                init_unit_sales_standard_revenue: { required: true, validator: checkNumber, trigger: 'blur' },
                init_unit_sales_standard_margin: { required: true, validator: checkNumber, trigger: 'blur' },
                province_sign: [{ required: false, message: '省份', trigger: 'blur' }],
                lock_sign: [{ required: false, message: '锁定标记', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id || '';
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                partner_rid: this.data.partner_rid || '',
                person_rid: this.data.person_rid || '',
                product_rid: this.data.product_rid || '',
                business_unit_rid: this.data.business_unit_rid || '',
                account_rid: this.data.account_rid || '',
                first_business_date: this.data.first_business_date || null,
                latest_business_date: this.data.latest_business_date || null,
                parameter: this.data.parameter || null,
                init_month_sequence: this.data.init_month_sequence || '',
                init_quantity: this.data.init_quantity,
                init_unit_price_taxincluded: this.data.init_unit_price_taxincluded || '0',
                init_unit_sales_standard_revenue: this.data.init_unit_sales_standard_revenue || '0',
                init_unit_sales_standard_margin: this.data.init_unit_sales_standard_margin || '0',
                status: this.data.status || 1,
                performance_basis_code: this.data.performance_basis_code || 1,
                performance_basis: this.data.performance_basis || 1,
                account_option: { rid: this.data.account_rid || '', name: this.data.account || '' },
                province_sign: this.data.province_sign || [],
                lock_sign: this.data.lock_sign || []
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).partner_product_account;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'first_business_date',
                        'latest_business_date',
                        'parameter',
                        'init_month_sequence',
                        'init_quantity',
                        'init_unit_price_taxincluded',
                        'init_unit_sales_standard_revenue',
                        'init_unit_sales_standard_margin'
                    ]
                },
                {
                    account: 'account_rid',
                    partner: 'partner_rid',
                    person: 'person_rid',
                    product: 'product_rid',
                    business_unit_code: 'business_unit_rid',
                    status_label: 'status',
                    performance_basis: 'performance_basis_code',
                    province_sign_label: 'province_sign',
                    lock_sign_label: 'lock_sign'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/partnerProductAccountList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .partnerProductAccountDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.data.province_sign = this.data.province_sign_array || [];
                    this.data.lock_sign = this.data.lock_sign_array || [];

                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'partnerProductAccountUpdate';
            } else {
                uri = 'partnerProductAccountInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>